import { defineStore } from 'pinia';

import { createTgMessenger } from './messengers/tg'
import { createMaxMessenger } from './messengers/max'
import stores from '@/stores';
const themes = import.meta.env.VITE_APP_THEMES ? import.meta.env.VITE_APP_THEMES.split(',') : [];

const back = () => {
    stores.nav().back();
}

const useMessengersStore = defineStore('messengers', {
    state: () => ({
        code: window.messenger?.code || 'tg',
        tg: createTgMessenger()(),
        max: createMaxMessenger()()
    }),
    getters: {
        theme: (state) => {
            return (state.code === 'tg' ? state.tg.theme : state.max.theme) || themes[0];
        },
        isTg: (state) => state.code === 'tg',
        isMax: (state) => state.code === 'max',
        msgr: (state) => state[state.code],
        base: (state) => state[state.code]?.base,
    },
    actions: {
        async init() {
            await this.msgr.init();

            // Locale
            if (this.msgr.locale) {
                stores.locale().parseMsgrLocale(this.msgr.locale);
            }

            // Theme
            // if (this.msgr.theme) {
            //     if (themes.includes(this.msgr.theme)) {
            //         this.theme = this.msgr.theme;
            //     }
            // }
        },
        async getLoginData() {
            return await this.msgr?.getLoginData();
        },
        updateMsgrColors() {
            this.msgr?.updateMsgrColors();
        },
        canLogin() {
            return this.msgr?.canLogin();
        },
        share(payload) {
            this.msgr?.share(payload);
        },
        getStartParam() {
            return this.msgr?.getStartParam();
        },
        getInitData() {
            return this.msgr?.getInitData();
        },
        getRef() {
            return this.msgr?.getRef();
        },
        getDefaultProfileImage() {
            return this.msgr?.getDefaultProfileImage();
        },
        openLink({ external_url, type, target }) {
            this.msgr?.openLink({ external_url, type, target });
        },
        showBackButton() {
            this.msgr?.showBackButton(back);
        },
        hideBackButton() {
            this.msgr?.hideBackButton(back);
        },
        showSettingsButton(callback) {
            this.msgr?.showSettingsButton(callback);
        },
        hideSettingsButton(callback) {
            this.msgr?.hideSettingsButton(callback);
        },
        vibrate(mode) {
            this.msgr?.vibrate(mode);
        }
    }
});

export default useMessengersStore;
